import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ title, src, path, params }) => {
    return (
        <div className="card h-100">
            <Link to={`/${path}`} state={params} className='text-decoration-none'>
                <img src={src} className="card-img-top" alt={title} style={{ height: 230 }} />
                <div className="card-body">
                    <h6 className="card-title fw-semibold small text-black">{title}</h6>
                </div>
            </Link>
        </div>
    );
};

export default ProjectCard;